const PUBLISH_ATTEMPT_WITHOUT_ALLOW_PUBLISH_STATUS =
  "Publish Attempt Without Allow Publish Status";
const SCHEDULE_PUBLISH_ATTEMPT_WITHOUT_ALLOW_PUBLISH_STATUS =
  "Schedule Publish Attempt Without Allow Publish Status";

export {
  PUBLISH_ATTEMPT_WITHOUT_ALLOW_PUBLISH_STATUS,
  SCHEDULE_PUBLISH_ATTEMPT_WITHOUT_ALLOW_PUBLISH_STATUS,
};
